var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(_vm._s(_vm.$t("menu.franchisee_manage"))),
    ]),
    _c(
      "div",
      { staticClass: "filter-section-container" },
      [
        _c("div", { staticClass: "filter-fixed" }, [
          _c("span", { staticClass: "filter-fixed-title" }, [
            _vm._v(_vm._s(_vm.$t("data.filter_section"))),
          ]),
          _c("i", {
            staticClass: "el-icon-arrow-down filter-fixed-arrow",
            class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
            on: {
              click: function ($event) {
                _vm.showFilterContent = !_vm.showFilterContent
              },
            },
          }),
        ]),
        _c("el-collapse-transition", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFilterContent,
                  expression: "showFilterContent",
                },
              ],
            },
            [
              _c("div", { staticClass: "filter-content" }, [
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("div", { staticClass: "filter-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("operation.franchisee_name"))),
                    ]),
                    _c("ScopeSelect", {
                      staticClass: "filter-item-value",
                      attrs: {
                        value: _vm.search.franchisee_id,
                        "is-remote": true,
                        "http-request-method": _vm.searchFranchiseeNameOptions,
                        "remote-params": _vm.getFranchiseeSearchParams,
                        "option-label": _vm.formatFranchisee,
                        "select-placeholder": _vm.$t(
                          "operation.select_franchisee"
                        ),
                      },
                      on: {
                        updateValue: function ($event) {
                          _vm.search.franchisee_id = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "filter-item" }),
                _c("div", { staticClass: "filter-item" }),
              ]),
              _c("div", { staticClass: "filter-operate" }, [
                _c(
                  "div",
                  { staticClass: "filter-operate-left" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-plus",
                        },
                        on: { click: _vm.openCreatePage },
                      },
                      [_vm._v(_vm._s(_vm.$t("operation.create_franchisee")))]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "filter-operate-right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.resetSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.clear")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.searchFranchisees },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.search")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "franchisee_no",
                label: _vm.$t("operation.franchisee_no"),
                "min-width": "150",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "franchisee_name",
                label: _vm.$t("operation.franchisee_name"),
                "min-width": "180",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "country_code",
                label: _vm.$t("operation.region"),
                "min-width": "140",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "currency",
                label: _vm.$t("operation.currency"),
                "min-width": "130",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "remark",
                label: _vm.$t("operation.remark"),
                "min-width": "220",
                align: "center",
                "show-overflow-tooltip": "",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "create_time",
                label: _vm.$t("operation.create_time"),
                "min-width": "170",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("components.operation"),
                "min-width": "150",
                align: "center",
                fixed: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openDetailPage(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.detail")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.openEditPage(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.edit")))]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.onPageChange },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }